import React from "react";
import { Link } from "react-router-dom";
import AcquaintanceCallbackForm from "../../pages/seo/AcquaintanceCallbackForm.jsx";

const CONTACT_COPY = {
  de: {
    title: "Brauchen Sie Hilfe beim Erstellen einer digitalen Speisekarte?",
    firstText:
      "Ich führe regelmäßig Online-Beratungen mit unseren Partnern durch. Sie können mich kontaktieren und erhalten zuverlässige Unterstützung.",
    secondText:
      "Sie können die einfache kostenlose Version auch selbst einrichten, mithilfe der Videoanleitung.",
    demo: "VIDEO ANSEHEN",
  },

  en: {
    title: "Do you need help creating a digital menu?",
    firstText:
      "I regularly conduct online consultations with our partners. You can contact me and receive guaranteed support.",
    secondText:
      "You can also set up the basic free version yourself using the video instructions.",
    demo: "WATCH VIDEO",
  },

  uk: {
    title: "Потрібна допомога зі створенням цифрового меню?",
    firstText:
      "Я регулярно проводжу онлайн-консультації з нашими партнерами. Ви можете зв’язатися зі мною та отримати гарантовану підтримку.",
    secondText:
      "Ви також можете самостійно налаштувати базову безкоштовну версію за допомогою відеоінструкцій.",
    demo: "ПЕРЕГЛЯНУТИ ВІДЕО",
  },

  fr: {
    title: "Avez-vous besoin d’aide pour créer un menu numérique ?",
    firstText:
      "Je réalise régulièrement des consultations en ligne avec nos partenaires. Vous pouvez me contacter et recevoir un accompagnement fiable.",
    secondText:
      "Vous pouvez également configurer vous-même la version de base gratuite à l’aide des instructions vidéo.",
    demo: "REGARDER LA VIDÉO",
  },

  nl: {
    title: "Heb je hulp nodig bij het maken van een digitaal menu?",
    firstText:
      "Ik geef regelmatig online consultaties aan onze partners. Je kunt contact met mij opnemen en betrouwbare ondersteuning krijgen.",
    secondText:
      "Je kunt de eenvoudige gratis versie ook zelf instellen met behulp van de video-instructies.",
    demo: "BEKIJK VIDEO",
  },

  pl: {
    title: "Potrzebujesz pomocy przy tworzeniu menu cyfrowego?",
    firstText:
      "Regularnie prowadzę konsultacje online z naszymi partnerami. Możesz się ze mną skontaktować i otrzymać pewne wsparcie.",
    secondText:
      "Możesz również samodzielnie skonfigurować podstawową bezpłatną wersję, korzystając z instrukcji wideo.",
    demo: "OBEJRZYJ FILM",
  },

  it: {
    title: "Hai bisogno di aiuto per creare un menu digitale?",
    firstText:
      "Svolgo regolarmente consulenze online con i nostri partner. Puoi contattarmi e ricevere supporto affidabile.",
    secondText:
      "Puoi anche configurare autonomamente la versione base gratuita seguendo le istruzioni video.",
    demo: "GUARDA IL VIDEO",
  },

  da: {
    title: "Har du brug for hjælp til at oprette en digital menu?",
    firstText:
      "Jeg afholder regelmæssigt online konsultationer med vores partnere. Du kan kontakte mig og få sikker støtte.",
    secondText:
      "Du kan også selv opsætte den enkle gratis version ved hjælp af videoinstruktionerne.",
    demo: "SE VIDEO",
  },

  es: {
    title: "¿Necesitas ayuda para crear un menú digital?",
    firstText:
      "Realizo consultas online regularmente con nuestros socios. Puedes contactarme y recibir apoyo garantizado.",
    secondText:
      "También puedes configurar tú mismo la versión básica gratuita con ayuda de las instrucciones en vídeo.",
    demo: "VER VÍDEO",
  },

  no: {
    title: "Trenger du hjelp med å lage en digital meny?",
    firstText:
      "Jeg gjennomfører jevnlig online konsultasjoner med våre partnere. Du kan kontakte meg og få trygg støtte.",
    secondText:
      "Du kan også sette opp den enkle gratisversjonen selv ved hjelp av videoinstruksjonene.",
    demo: "SE VIDEO",
  },
};

function normalizeSeoLang(value) {
  const v = String(value || "").trim().toLowerCase();
  return CONTACT_COPY[v] ? v : "de";
}

export default function SeoContactSection({
  lang = "en",
  apiOrigin = "",
  title,
}) {
  const currentLang = normalizeSeoLang(lang);
  const copy = CONTACT_COPY[currentLang];

  const sectionTitle = title || copy.title;

  return (
    <section className="acquaintance">
      <div className="title__to-wrapper">
        <h2 className="title title__to">{sectionTitle}</h2>
      </div>

      <div className="acquaintance__block">
        <div className="acquaintance__picture-block">
          <div className="acquaintance__picture-wrapper">
            <div className="acquaintance__picture"></div>
          </div>
        </div>

        <div className="acquaintance__presetation">
          <span className="acquaintance__text-sales">
            {copy.firstText}
          </span>

          <AcquaintanceCallbackForm
            apiOrigin={apiOrigin}
            lang={currentLang}
          />

          <span className="acquaintance__text-sales">
            {copy.secondText}
          </span>

          <Link to={`/${currentLang}/demo`} className="qrArticle__btn">
            {copy.demo}
          </Link>
        </div>
      </div>
    </section>
  );
}